import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const ContactoComponent = () => {
  return (
    <Container fluid className="bg-light pt-5 mb-5">
      <h1 className="text-center mb-4">Visítanos</h1>

      <Row className="g-4 justify-content-center">
        {/* Columna del mapa */}
        <Col xs={12} md={6} lg={5} className="px-3">
          <div
            style={{
              height: "400px",
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Sombra suave
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15904.53155682226!2d-74.0996104!3d4.7469486!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f85ed6519f6d7%3A0x846619076f3cf527!2sMorena%20m%C3%ADa%20Caf%C3%A9%20Suba!5e0!3m2!1ses!2sco!4v1737340312863!5m2!1ses!2sco"
              width="100%"
              height="100%"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación en Google Maps"
            ></iframe>
          </div>
        </Col>

        {/* Columna de la tarjeta */}
        <Col xs={12} md={6} lg={5} className="px-3">
          <div
            style={{
              backgroundImage: "url('/assets/dist/img/cafe.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "400px",
              borderRadius: "10px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", // Sombra suave
            }}
          >
            <Card
              className="shadow-sm border-0 text-white h-100"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                borderRadius: "10px",
              }}
            >
              <Card.Body className="text-center d-flex flex-column justify-content-center p-4">
                <h4>¡Ven a visitarnos!</h4>
                <p>
                  Cra. 109A #142 97, Parque Lombardia, Suba
                </p>
                <p>Bogotá. Colombia</p>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactoComponent;
